//

export const apiUrl = window.location.hostname === 'localhost' ? 'http://localhost:3001' : window.location.protocol + '//' + window.location.host;
